/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
    TransactionTypeToJSONTyped,
} from './TransactionType';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';
import type { TransactionStatus } from './TransactionStatus';
import {
    TransactionStatusFromJSON,
    TransactionStatusFromJSONTyped,
    TransactionStatusToJSON,
    TransactionStatusToJSONTyped,
} from './TransactionStatus';

/**
 * Payload to create a new inbound payment transaction.
 * @export
 * @interface CreateTransactionRequest
 */
export interface CreateTransactionRequest {
    /**
     * 
     * @type {TransactionType}
     * @memberof CreateTransactionRequest
     */
    transactionType: TransactionType;
    /**
     * 
     * @type {number}
     * @memberof CreateTransactionRequest
     */
    amountCents: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTransactionRequest
     */
    feeCents?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    transactionDate: string;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof CreateTransactionRequest
     */
    paymentMethod?: PaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    payee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    payer?: string | null;
    /**
     * 
     * @type {TransactionStatus}
     * @memberof CreateTransactionRequest
     */
    status?: TransactionStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionRequest
     */
    notes?: string | null;
}



/**
 * Check if a given object implements the CreateTransactionRequest interface.
 */
export function instanceOfCreateTransactionRequest(value: object): value is CreateTransactionRequest {
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    return true;
}

export function CreateTransactionRequestFromJSON(json: any): CreateTransactionRequest {
    return CreateTransactionRequestFromJSONTyped(json, false);
}

export function CreateTransactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTransactionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionType': TransactionTypeFromJSON(json['transactionType']),
        'amountCents': json['amountCents'],
        'feeCents': json['feeCents'] == null ? undefined : json['feeCents'],
        'transactionDate': json['transactionDate'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : PaymentMethodFromJSON(json['paymentMethod']),
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'payee': json['payee'] == null ? undefined : json['payee'],
        'payer': json['payer'] == null ? undefined : json['payer'],
        'status': json['status'] == null ? undefined : TransactionStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateTransactionRequestToJSON(json: any): CreateTransactionRequest {
    return CreateTransactionRequestToJSONTyped(json, false);
}

export function CreateTransactionRequestToJSONTyped(value?: CreateTransactionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionType': TransactionTypeToJSON(value['transactionType']),
        'amountCents': value['amountCents'],
        'feeCents': value['feeCents'],
        'transactionDate': value['transactionDate'],
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'referenceNumber': value['referenceNumber'],
        'payee': value['payee'],
        'payer': value['payer'],
        'status': TransactionStatusToJSON(value['status']),
        'notes': value['notes'],
    };
}

